import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../common/SectionHeading';
import Testimonial from '../common/Testimonial';

const SectionContainer = styled.section`
  background-color: #121212;
  color: #FFFFFF;
  padding: 100px 0;
  
  @media (max-width: 768px) {
    padding: 80px 0;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 60px 0;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const OverallRating = styled.div`
  text-align: center;
  margin-top: 40px;
  
  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 18px;
    color: #FFD700;
  }
`;

const Stars = styled.div`
  color: #FFD700;
  font-size: 24px;
  margin-bottom: 8px;
`;

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "CarConsul helped me negotiate a much better deal on my Honda Accord. The AI found common issues I should check for and gave me exact figures on what others paid.",
      name: "Jennifer R.",
      car: "Honda Accord Sport",
      savings: "525"
    },
    {
      quote: "I was between a Toyota RAV4 and Mazda CX-5. CarConsul's detailed comparison made it clear which one better fit my needs. Saved me hours of research!",
      name: "Michael T.",
      car: "Mazda CX-5",
      savings: "400"
    },
    {
      quote: "The negotiation scripts were gold! I walked into the dealership confident and prepared. The salesperson was surprised by how much I knew about invoice pricing.",
      name: "Sarah L.",
      car: "Kia Telluride",
      savings: "620"
    }
  ];

  return (
    <SectionContainer>
      <Content>
        <SectionHeading 
          title="What Car Buyers Are Saying" 
          subtitle="See how CarConsul has helped thousands of car buyers make better decisions"
        />
        
        <TestimonialsGrid>
          {testimonials.map((testimonial, index) => (
            <Testimonial
              key={index}
              quote={testimonial.quote}
              name={testimonial.name}
              car={testimonial.car}
              savings={testimonial.savings}
              animationDelay={index * 0.1}
            />
          ))}
        </TestimonialsGrid>
        
        <OverallRating>
          <Stars>★★★★★</Stars>
          <span>4.8/5 stars</span>
        </OverallRating>
      </Content>
    </SectionContainer>
  );
};

export default TestimonialsSection;
